<template>
	<div class="header-actions">
		<button class="action-btn primary" @click="onSave" :disabled="loading">
			{{ saveLabel }}
		</button>
		<button v-if="showDelete" class="action-btn danger" @click="onDelete" :disabled="loading || !hasId">
			{{ deleteLabel }}
		</button>
		<button class="action-btn secondary" @click="onNew" :disabled="loading">
			{{ newLabel }}
		</button>
	</div>
</template>

<script>
export default {
	name: 'AdminHeaderActions',
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		hasId: {
			type: Boolean,
			default: true
		},
		showDelete: {
			type: Boolean,
			default: true
		},
		saveLabel: {
			type: String,
			default: '💾 Save'
		},
		deleteLabel: {
			type: String,
			default: '🗑️ Delete'
		},
		newLabel: {
			type: String,
			default: '➕ New'
		}
	},
	methods: {
		onSave() {
			this.$emit('save');
		},
		onDelete() {
			this.$emit('delete');
		},
		onNew() {
			this.$emit('new');
		}
	}
}
</script>

<style scoped>
.header-actions {
	display: flex;
	gap: 6px;
	flex-wrap: wrap;
}

.action-btn {
	padding: 6px 10px;
	border: none;
	border-radius: var(--border-radius-s);
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	white-space: nowrap;
}

.action-btn.primary {
	background-color: #4caf50;
	color: #ffffff;
}

.action-btn.primary:hover:not(:disabled) {
	background-color: #45a049;
	transform: translateY(-2px);
}

.action-btn.secondary {
	background-color: var(--admin-hover-bg);
	color: var(--admin-text-primary);
	border: 1px solid var(--admin-border);
}

.action-btn.secondary:hover:not(:disabled) {
	background-color: var(--admin-active-bg);
	transform: translateY(-2px);
}

.action-btn.danger {
	background-color: rgba(211, 47, 47, 0.1);
	color: #d32f2f;
	border: 1px solid rgba(211, 47, 47, 0.3);
}

.action-btn.danger:hover:not(:disabled) {
	background-color: rgba(211, 47, 47, 0.2);
	transform: translateY(-2px);
}

.action-btn:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
</style>
